export default __webpack_public_path__ + "static/media/shape-star.d56ed51c.svg";